import type { TGooglePublisherTag } from './types';

const initGpt = () => {
  window.googletag.cmd.push(() => {
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().disableInitialLoad();

    googletag.pubads().setCentering(true);

    googletag.pubads().setTargeting('allowtransparency', '');
    googletag.pubads().enableLazyLoad({
      fetchMarginPercent: 50, // Fetch slots within 50% of the viewport
      renderMarginPercent: 0, // Only render slots when they are in view
      mobileScaling: -1, // No scaling for mobile
    });
    googletag.enableServices();
  });
};

// Using Singleton pattern here to ensure that the script is only loaded once for all ads
let gptScript: Promise<TGooglePublisherTag> | null = null;
export const loadScript = (): Promise<TGooglePublisherTag> => {
  if (!gptScript) {
    gptScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = 'https://www.googletagservices.com/tag/js/gpt.js';
      script.onload = () => {
        initGpt();
        resolve(window.googletag);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return gptScript;
};
